import { useQuery } from '@apollo/client/react'
import { Card, Input } from 'antd'
import { useEffect, useState } from 'react'
import { type Customer, CustomersDocument } from '~app/graph/generated/graphql'

interface Props {
  onSelectionChange: (selectedUser?: Customer | undefined) => void
  email?: string
}

const CustomerEmailSearchForm = (props: Props) => {
  const [email, setEmail] = useState(props.email)
  const { data, loading } = useQuery(CustomersDocument, {
    skip: !email,
    variables: {
      // @TODO should be a fuzzy matching
      where: { email },
    },
  })

  useEffect(() => {
    props.onSelectionChange(data?.customers?.[0])
  }, [data])

  return (
    <Card>
      <Input.Search
        placeholder="E-mail"
        enterButton
        loading={loading}
        onSearch={setEmail}
        defaultValue={props.email}
      />
    </Card>
  )
}

export default CustomerEmailSearchForm
